import BScroll from "./BScroll";

export default class BForm
{
	constructor(el)
	{
		this.el = el;
	}

	getMethod()
	{
		return this.el.dataset?.method ?? this.el?.method;
	}

	getURL()
	{
		return this.el.action;
	}

	getData()
	{
		let data = {};
		let formData = new FormData(this.el);

		for (let pair of formData.entries()) {
			data[pair[0]] = pair[1];
		}

		return data;
	}

	getErrorsElement()
	{
		return this.el.querySelector(`.b-errors`);
	}

	resetErrors()
	{
		this.el.querySelectorAll(`.b-errors`).forEach(el => {
			el.innerHTML = "";
			el.hidden = true;
		});

		this.el.querySelectorAll(`.has-error`).forEach(el => {
			el.classList.remove("has-error");
		});
	}

	setErrorResponse(errorResponse)
	{
		this.resetErrors();

		for (let error of errorResponse.data) {
			this.setError(error);
		}

		const offset = -15;
		const inputsInError = this.el.querySelectorAll(`.b-input__input.has-error`);
		if (inputsInError.length) {
			BScroll.top(inputsInError[0].closest(`.b-input`), offset);
		} else {
			const genericErrorBlock = Array.from(this.el.querySelectorAll(`.b-errors.b-errors--block`)).filter(el => {
				return !el.hidden;
			});
			if (genericErrorBlock.length) {
				BScroll.top(genericErrorBlock[0], offset);
			}
		}
	}

	getNamedErrorElements()
	{
		let elements = {};
		this.el.querySelectorAll(`.b-errors[data-name]`).forEach(el => {
			elements[el.dataset.name] = el;
		});

		return elements;
	}

	setError(error)
	{
		let names = [];
		if (error?.params) {
			for (let key of Object.getOwnPropertyNames(error?.params)) {
				names.push(error.params[key].key);
				for (let alias of (error.params[key]?.aliases ?? [])) {
					names.push(alias);
				}
			}
		}
		names = names.filter((value, index, self) => {
			try {
				return value.trim().length && self.indexOf(value) === index;
			} catch (error) {
				return null;
			}
		});

		let errorDisplayed = false;

		if (names.length) {
			for (let name of names) {
				let element = this.getNamedErrorElements()[name];
				if (element) {
					this.setNamedError(name, error.message);
					errorDisplayed = true;
				}
			}
		}

		if (!errorDisplayed) {
			this.setUnnamedError(error.message);
		}
	}

	static getErrorMessageHtml(message)
	{
		return `<p class="b-errors__error">${message}</p>`;
	}

	setNamedError(name, message)
	{
		const errorMessageElement = this.el.querySelector(`.b-errors[data-name="${name}"]`);
		if (errorMessageElement) {
			errorMessageElement.innerHTML += BForm.getErrorMessageHtml(message);
			errorMessageElement.hidden = false;
		} else {
			this.setUnnamedError(message);
		}

		const errorInputElement = this.el.querySelector(`[name="${name}"]`);
		if (errorInputElement) {
			errorInputElement.classList.add("has-error");
		}
	}

	setUnnamedError(message)
	{
		const errorMessageElement = this.getErrorsElement();
		if (errorMessageElement) {
			errorMessageElement.innerHTML += BForm.getErrorMessageHtml(message);
			errorMessageElement.hidden = false;
		}
	}

	disable()
	{
		this.el.querySelectorAll("input, textarea, select, button").forEach(el => {
			el.disabled = true;
		});
	}

	enable()
	{
		this.el.querySelectorAll("input, textarea, select, button").forEach(el => {
			el.disabled = false;
		});
	}

	reset()
	{
		this.el.querySelectorAll("input, textarea, select, button").forEach(el => {
			el.value = null;
		});
	}
}
